export default "__VITE_ASSET__BVtxiL_8__"